export const NNormalProfileSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none" {...props}>
    <rect width="50" height="50" rx="25" fill="black" />
    <path
      d="M13 35.5915C13 31.7183 16.262 28.5493 20.249 28.5493H29.6726C33.6595 28.5493 36.9216 31.7183 36.9216 35.5915V37H13V35.5915ZM24.9608 26.0845C28.9477 26.0845 32.2097 22.9155 32.2097 19.0423C32.2097 15.169 28.9477 12 24.9608 12C20.9739 12 17.7118 15.169 17.7118 19.0423C17.7118 22.9155 20.9739 26.0845 24.9608 26.0845Z"
      fill="white"
    />
  </svg>
);
